import { boot } from 'quasar/wrappers'
import * as Sentry from '@sentry/vue'

export default boot(({ app, router }) => {
  Sentry.init({
    app,
    dsn:
      process.env.NODE_ENV === 'development'
        ? null
        : 'https://82f705ad09b442168d0e7f91504dbbcf@o1018935.ingest.sentry.io/5984781',
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
    logErrors: process.env.NODE_ENV === 'development',
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.01,
    replaysOnErrorSampleRate: 0,
    replaysSessionSampleRate: 0,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'Non-Error exception captured',
      'Non-Error promise rejection captured',
      'Network Error',
      'Request failed with status code 403',
      'Request failed with status code 401',
      'AbortError: The operation was aborted.',
      'Importing a module script failed.',
      'ResizeObserver loop completed with undelivered notifications.'
    ]
  })
})
